import React from 'react'

import Checkbox from '../../checkbox'

export default ({ value, onChange, ...props }) => (
  <Checkbox
    {...props}
    checked={value}
    onChange={(evt) => {
      onChange?.(evt.target.checked)
    }}
  />
)
